<script setup>
import {ref} from "vue";
import createTenantBrand from "./components/createTenantBrand/index.vue";
import router from "@/router/index.js";
import {addBrand} from "@/api/brand/ignoreTenant.js";

// 加载状态
const loading = ref(false)
/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: "Coming Soon ...",
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null
  },
  tenantId: null,
  // 营业时间
  operatingHours: [{
    operatingTime: [],
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null
  }],
  referralOfficer: {
    name: null,
    phone: null
  },
  certificationType: null,
  partnerStores: [],
  description: null,
  descriptionEn: "Coming Soon ...",
  descriptionImages: [],
  descriptionEnImages: [],
  // 负责人信息
  contactName: null,
  phone: null,
  contactEmail: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  // 退货地址信息
  storeReturnAddress: {
    recipientName: null,
    contactPhone: null,
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null
  },
  // 商城售后规则
  preShipmentAfterSaleTypes: ["REFUND"],
  postShipmentAfterSaleTypes: ["RETURN_REFUND", "EXCHANGE", "RESHIP"],
  returnFreightType: null,
  // 售后联系人信息
  afterSaleContact: null,
  afterSalePhone: null,
  assistsOperation: true,
  storeCoverImage: null,
  photoList: []
})
// 处理表单提交新建俱乐部
const handleCreateTenantBrand = async () => {
  try {
    loading.value = true
    await addBrand(ruleForm.value)
    router.push({ path: "/listTenantBrand" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createTenantBrand v-model="ruleForm" @success="handleCreateTenantBrand"></createTenantBrand>
  </div>
</template>

<style scoped>

</style>
